import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { ChipToggleModule } from '@components/chip-toggle/chip-toggle.module';
import { InvestmentMovementModule } from '@components/investment-movement/investment-movement.module';
import { InvestmentMovementListComponent } from './investment-movement-list.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    RouterModule,
    InvestmentMovementModule,
    ChipToggleModule,
  ],
  declarations: [
    InvestmentMovementListComponent,
  ],
  exports: [
    InvestmentMovementListComponent,
  ],
})
export class InvestmentMovementListModule { }
